import request from '@/utils/request';
export function getDataByStratigraphy(stratigraphy) {
  return request.get(`/OAE/getAll${stratigraphy}`);
}
